import { getGlobalContext } from './globalContext';
export default function createActionId() {
    return (getGlobalContext().nextActionId++).toString();
}
